import ItodoImage from "../../../elements/itodo-img";

function SectionAboutCompany2Inner() {
  return (
    <>
      <div className="sx-about-bx3-content-wrap sx-about-bx3-content-wrap-home2">
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="sx-about-bx3-media">
              <div className="sx-dot-bx1"><ItodoImage src="https://images.unsplash.com/photo-1485230405346-71acb9518d9c?auto=format&fit=crop&w=700&h=1000&q=80" alt="woman security officer on patrol" /></div>
              <div className="sx-dot-bx2"><ItodoImage src="https://images.unsplash.com/photo-1573164574230-db1d5e960238?auto=format&fit=crop&w=700&h=1000&q=80" alt="night patrol security protection" /></div>
              <div className="sx-ab3-img-outer"><div className="sx-ab3-media"><ItodoImage src="https://images.unsplash.com/photo-1584143257259-50212e2ab820?auto=format&fit=crop&w=1200&h=1600&q=80" alt="focused operational security team" /></div></div>
              <div className="sx-ab-circle-box"><div className="sx-ab-circle-box-content"><span className="sx-exp">Regional Security Expertise</span><div className="sx-exp-title-outer"><span className="sx-exp-title-1">Neuron</span><span className="sx-exp-title-2">Consultancy</span></div></div></div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="sx-about-bx3-content">
              <h2 className="sx-title">About Neuron Consultancy Kenya Ltd</h2>
              <span className="sx-title-2">Kenyan-based risk and threat mitigation for corporate and private sector clients.</span>
              <p>We provide close protection, VIP protection, surveillance and travel security with disciplined standards and reliable operational control.</p>
              <p>Our teams are selected for field competence, integrity and readiness to support mission-critical operations across the region.</p>
              <div className="row sx-about-icon-bx3-column">
                <div className="col-lg-6 col-md-6"><div className="sx-icon-bx-3"><div className="sx-media"><i className="flaticon-incoming-call" /></div><div className="sx-icon-bx-info"><span className="sx-icon-bx-title-info">Contact Phone</span><span className="sx-icon-bx-title">+254 725 642 469</span></div></div></div>
                <div className="col-lg-6 col-md-6"><div className="sx-icon-bx-3"><div className="sx-media"><i className="flaticon-email-1" /></div><div className="sx-icon-bx-info"><span className="sx-icon-bx-title-info">Contact Mail</span><span className="sx-icon-bx-title">info@neuronconsultancy.co.ke</span></div></div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hilite-title text-left p-l50 text-uppercase"><strong>About Us</strong></div>
    </>
  );
}

export default SectionAboutCompany2Inner;
